import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { ICreditsStatistics } from "../domain/ICreditsStatistics";
import { StatisticsService } from "../services/statistics.service";

interface CreditsStatisticsState {
  loading: boolean;
  statistics?: ICreditsStatistics;
  error: any;
}

const initialState: CreditsStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getCreditsStatistics = createAsyncThunk(
  "Statistics/getCreditsStatistics",
  async (data?: IConstructionStatisticsRequestParams) => {
    try {
      const result = await StatisticsService.getCreditsStatistics(data);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const CreditsStatisticsSlice = createSlice({
  name: "CreditsStatistics",
  initialState: initialState,
  reducers: {
    setCreditsStatistics: (
      state,
      action: PayloadAction<ICreditsStatistics>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCreditsStatistics.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getCreditsStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload ? action.payload: undefined;
    });
    builder.addCase(getCreditsStatistics.rejected, (state,action) => {
        state.loading = false;
        state.error = action.error;
    });
  }
});

export const selectState = (state: RootState) => state.statistics.credits;

export const { setError } = CreditsStatisticsSlice.actions;

export default CreditsStatisticsSlice.reducer;
